import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div<{ $active?: boolean }>`
	position: relative;
	width: 30px;
	height: 30px;

	stop {
		transition:
			stop-color 0.3s ease,
			stop-opacity 0.3s ease;
	}

	${Text} {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		font-weight: 700;
		font-size: 16px;
		color: ${(props) => (props.$active ? '#FFFFFF' : '#000000')};
		text-transform: uppercase;
		transition: color 0.3s ease;
	}
`;

export { StyledContainer };
